import React, { useEffect } from "react";
import { Button } from "./ui/button";
import { Card, CardContent } from "./ui/card";
import { useForm } from "react-hook-form";
import { HookInput, HookSelect } from "../helpers/formHelpers";

const isAFAP = (v: unknown) =>
  typeof v === "string" && v.trim().toUpperCase() === "AFAP";

const isNumericLike = (v: unknown) => {
  if (v === undefined || v === null || v === "") return false;
  const n = typeof v === "number" ? v : parseFloat(String(v));
  return Number.isFinite(n);
};

const validateRate = (v: unknown) =>
  isAFAP(v) || isNumericLike(v) || "Must be a number (or AFAP)";

const validateNumber = (v: unknown) =>
  isNumericLike(v) || "Must be a number";

const SegmentForm = ({ onSubmit, initialValues }: { onSubmit: any; initialValues: any }) => {
  const {
    control,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm({ defaultValues: initialValues });

  // Re-initialize when initialValues change (e.g. preferences load late)
  useEffect(() => {
    if (initialValues) {
      reset(initialValues);
    }
  }, [initialValues, reset]);

  return (
    <div>
      <form onSubmit={handleSubmit(onSubmit)}>
        <Card><CardContent>
          <HookInput control={control} name="name" label="Segment Name" errors={errors} />
          <HookInput
            control={control}
            name="rate"
            label="Rate"
            errors={errors}
            rules={{ required: "Required", validate: validateRate }}
          />
          <HookInput
            control={control}
            name="temperature"
            label="Temperature"
            errors={errors}
            rules={{ required: "Required", validate: validateNumber }}
          />
          <HookInput
            control={control}
            name="hold"
            label="Hold Time (mins)"
            errors={errors}
            rules={{ required: "Required", validate: validateNumber }}
          />
          <HookSelect
            control={control}
            name="degrees"
            label="Degrees"
            errors={errors}
            items={[
              { label: "Celsius", value: "celsius" },
              { label: "Fahrenheit", value: "fahrenheit" },
            ]}
          />
        </CardContent></Card>
        <Card><CardContent>
          <Button variant="outline" type="submit">Update</Button>
        </CardContent></Card>
      </form>
    </div>
  );
};

export default SegmentForm;
